import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import * as moment from "moment";
import { Device } from "../../../models/device";
import { I18N } from "aurelia-i18n";

@autoinject
export class CurtainControllerChart extends BaseDeviceChart {
 
	constructor(api: Api, i18N: I18N) {
		super(api, i18N);
	}

	activate(device: Device) {
		this.bindDevice(device);
	}

	attached() {
		setTimeout(() => {
				this.isAttached = true;
			},
			100);
	}

}